<template>
  <skeleton :button="buttonLabel" :background="background" @next="$emit('next')">
    <vv-speech-bubble :title="boxTitle">
      {{ boxText }}
    </vv-speech-bubble>

    <div class="tips-container">
      <vv-single-tip v-for="(tip, index) in tips" :key="index" :label="tip" no-border />
    </div>
  </skeleton>
</template>

<script>
import { VvSpeechBubble, VvSingleTip } from '@/components/common'
import Skeleton from './TransitionSkeleton'

export default {
  name: 'SpeechTransition',
  components: { VvSpeechBubble, Skeleton, VvSingleTip },
  props: {
    background: String,
    boxText: String,
    boxTitle: String,
    buttonLabel: String,
    facts: Array
  },
  computed: {
    tips() {
      return this.facts.map(fact => fact.label)
    }
  }
}
</script>

<style lang="scss" scoped>
.tips-container {
  padding: 0 20px;
  margin-top: 40px;
}
</style>
